// src/store/index.ts
// eslint-disable-next-line import/no-extraneous-dependencies
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import appSlice from 'modules/app/store';
import postSlice from './../modules/feed/store/index';
import feedSlice from './feedSlice'; // already imported

const rootReducer = combineReducers({
  postSlice,
  appSlice,
  feedSlice, // add this line
})

export const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch